import type { TutorApplicationStore } from './interfaces'

const setFullName = (state: TutorApplicationStore, payload: TutorApplicationStore['fullName']): void => {
  state.fullName = payload
}

const setEmailValid = (state: TutorApplicationStore, payload: TutorApplicationStore['emailValid']): void => {
  state.emailValid = payload
}

const setEmail = (state: TutorApplicationStore, payload: TutorApplicationStore['email']): void => {
  state.email = payload
}

const setPhoneNumber = (state: TutorApplicationStore, payload: TutorApplicationStore['phoneNumber']): void => {
  state.phoneNumber = payload
}

const setCv = (state: TutorApplicationStore, payload: TutorApplicationStore['cv']): void => {
  state.cv = payload
}

const setCoverLetter = (state: TutorApplicationStore, payload: TutorApplicationStore['coverLetter']): void => {
  state.coverLetter = payload
}

const setNationality = (state: TutorApplicationStore, payload: TutorApplicationStore['nationality']): void => {
  state.nationality = payload
}

const setAgeConfirmation = (state: TutorApplicationStore, payload: TutorApplicationStore['ageConfirmation']): void => {
  state.ageConfirmation = payload
}

const setRecommended = (state: TutorApplicationStore, payload: TutorApplicationStore['recommended']): void => {
  state.recommended = payload
}

const setReferrerFullName = (state: TutorApplicationStore, payload: TutorApplicationStore['referrerFullName']): void => {
  state.referrerFullName = payload
}

const setReferralSource = (state: TutorApplicationStore, payload: TutorApplicationStore['referralSource']): void => {
  state.referralSource = payload
}

const setJobPostingSite = (state: TutorApplicationStore, payload: TutorApplicationStore['jobPostingSite']): void => {
  state.jobPostingSite = payload
}

const setHasBachelorDegree = (state: TutorApplicationStore, payload: TutorApplicationStore['hasBachelorDegree']): void => {
  state.hasBachelorDegree = payload
}

const setTeachingExperienceYears = (state: TutorApplicationStore, payload: TutorApplicationStore['teachingExperienceYears']): void => {
  state.teachingExperienceYears = payload
}

const setWorkRequiredSchedule = (state: TutorApplicationStore, payload: TutorApplicationStore['workRequiredSchedule']): void => {
  state.workRequiredSchedule = payload
}

const setOnboardingTimeframe = (state: TutorApplicationStore, payload: TutorApplicationStore['onboardingTimeframe']): void => {
  state.onboardingTimeframe = payload
}

const setAcceptEmailDelivery = (state: TutorApplicationStore, payload: TutorApplicationStore['acceptEmailDelivery']): void => {
  state.acceptEmailDelivery = payload
}

const setAcceptConfidentiality = (state: TutorApplicationStore, payload: TutorApplicationStore['acceptConfidentiality']): void => {
  state.acceptConfidentiality = payload
}

const setAcceptNotRestrictedResident = (state: TutorApplicationStore, payload: TutorApplicationStore['acceptNotRestrictedResident']): void => {
  state.acceptNotRestrictedResident = payload
}

const setAcceptDataProcessingTerms = (state: TutorApplicationStore, payload: TutorApplicationStore['acceptDataProcessingTerms']): void => {
  state.acceptDataProcessingTerms = payload
}

const setShowErrors = (state: TutorApplicationStore, payload: TutorApplicationStore['showErrors']): void => {
  state.showErrors = payload
}

const setAmplitudeId = (state: TutorApplicationStore, payload: TutorApplicationStore['amplitudeId']): void => {
  state.amplitudeId = payload
}

const resetCv = (state: TutorApplicationStore): void => {
  setCv(state, null)
  setShowErrors(state, false)
}

const resetCoverLetter = (state: TutorApplicationStore): void => {
  setCoverLetter(state, null)
  setShowErrors(state, false)
}

const resetPersonalInformation = (state: TutorApplicationStore): void => {
  setFullName(state, '')
  setEmail(state, '')
  setEmailValid(state, false)
  setPhoneNumber(state, '')
  setShowErrors(state, false)
}

const resetAdditionalQuestions = (state: TutorApplicationStore): void => {
  setNationality(state, '')
  setAgeConfirmation(state, null)
  setRecommended(state, null)
  setReferrerFullName(state, '')
  setReferralSource(state, null)
  setJobPostingSite(state, '')
  setHasBachelorDegree(state, null)
  setTeachingExperienceYears(state, null)
  setWorkRequiredSchedule(state, null)
  setOnboardingTimeframe(state, null)
  setShowErrors(state, false)
}

const resetLegalAgreements = (state: TutorApplicationStore): void => {
  setAcceptEmailDelivery(state, false)
  setAcceptConfidentiality(state, false)
  setAcceptNotRestrictedResident(state, false)
  setAcceptDataProcessingTerms(state, false)
  setShowErrors(state, false)
}

const resetForm = (state: TutorApplicationStore): void => {
  resetPersonalInformation(state)
  resetCv(state)
  resetCoverLetter(state)
  resetAdditionalQuestions(state)
  resetLegalAgreements(state)
  setShowErrors(state, false)
}

export const actions = {
  setFullName (this: TutorApplicationStore, payload: TutorApplicationStore['fullName']): void {
    setFullName(this, payload)
  },

  setEmailValid (this: TutorApplicationStore, payload: TutorApplicationStore['emailValid']): void {
    setEmailValid(this, payload)
  },

  setEmail (this: TutorApplicationStore, payload: TutorApplicationStore['email']): void {
    setEmail(this, payload)
  },

  setPhoneNumber (this: TutorApplicationStore, payload: TutorApplicationStore['phoneNumber']): void {
    setPhoneNumber(this, payload)
  },

  setCv (this: TutorApplicationStore, payload: TutorApplicationStore['cv']): void {
    setCv(this, payload)
  },

  setCoverLetter (this: TutorApplicationStore, payload: TutorApplicationStore['coverLetter']): void {
    setCoverLetter(this, payload)
  },

  setNationality (this: TutorApplicationStore, payload: TutorApplicationStore['nationality']): void {
    setNationality(this, payload)
  },

  setAgeConfirmation (this: TutorApplicationStore, payload: TutorApplicationStore['ageConfirmation']): void {
    setAgeConfirmation(this, payload)
  },

  setRecommended (this: TutorApplicationStore, payload: TutorApplicationStore['recommended']): void {
    setRecommended(this, payload)
  },

  setReferrerFullName (this: TutorApplicationStore, payload: TutorApplicationStore['referrerFullName']): void {
    setReferrerFullName(this, payload)
  },

  setReferralSource (this: TutorApplicationStore, payload: TutorApplicationStore['referralSource']): void {
    setReferralSource(this, payload)
  },

  setJobPostingSite (this: TutorApplicationStore, payload: TutorApplicationStore['jobPostingSite']): void {
    setJobPostingSite(this, payload)
  },

  setHasBachelorDegree (this: TutorApplicationStore, payload: TutorApplicationStore['hasBachelorDegree']): void {
    setHasBachelorDegree(this, payload)
  },

  setTeachingExperienceYears (this: TutorApplicationStore, payload: TutorApplicationStore['teachingExperienceYears']): void {
    setTeachingExperienceYears(this, payload)
  },

  setWorkRequiredSchedule (this: TutorApplicationStore, payload: TutorApplicationStore['workRequiredSchedule']): void {
    setWorkRequiredSchedule(this, payload)
  },

  setOnboardingTimeframe (this: TutorApplicationStore, payload: TutorApplicationStore['onboardingTimeframe']): void {
    setOnboardingTimeframe(this, payload)
  },

  setAcceptEmailDelivery (this: TutorApplicationStore, payload: TutorApplicationStore['acceptEmailDelivery']): void {
    setAcceptEmailDelivery(this, payload)
  },

  setAcceptConfidentiality (this: TutorApplicationStore, payload: TutorApplicationStore['acceptConfidentiality']): void {
    setAcceptConfidentiality(this, payload)
  },

  setAcceptNotRestrictedResident (this: TutorApplicationStore, payload: TutorApplicationStore['acceptNotRestrictedResident']): void {
    setAcceptNotRestrictedResident(this, payload)
  },

  setAcceptDataProcessingTerms (this: TutorApplicationStore, payload: TutorApplicationStore['acceptDataProcessingTerms']): void {
    setAcceptDataProcessingTerms(this, payload)
  },

  setShowErrors (this: TutorApplicationStore, payload: TutorApplicationStore['showErrors']): void {
    setShowErrors(this, payload)
  },

  setAmplitudeId (this: TutorApplicationStore, payload: TutorApplicationStore['amplitudeId']): void {
    setAmplitudeId(this, payload)
  },

  resetPersonalInformation (this: TutorApplicationStore): void {
    resetPersonalInformation(this)
  },

  resetCv (this: TutorApplicationStore): void {
    resetCv(this)
  },

  resetCoverLetter (this: TutorApplicationStore): void {
    resetCoverLetter(this)
  },

  resetAdditionalQuestions (this: TutorApplicationStore): void {
    resetAdditionalQuestions(this)
  },

  resetLegalAgreements (this: TutorApplicationStore): void {
    resetLegalAgreements(this)
  },

  resetForm (this: TutorApplicationStore): void {
    resetForm(this)
  },
}
